<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="viewBox"
  >
    <g data-name="グループ 11960">
      <path
        data-name="パス 4975"
        d="M679.5 453.75a.749.749 0 0 0-.75-.75h-6a.75.75 0 0 0 0 1.5h6a.749.749 0 0 0 .75-.75z"
        transform="translate(-670.5 -443.25)"
        :style="{ fill: color }"
      />
      <path
        data-name="パス 4976"
        d="M680 457.75a.749.749 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5a.749.749 0 0 0 .75-.75z"
        transform="translate(-671 -444.25)"
        :style="{ fill: color }"
      />
      <path
        data-name="パス 4977"
        d="M680.5 461.75a.749.749 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h3a.749.749 0 0 0 .75-.75z"
        transform="translate(-671.5 -445.25)"
        :style="{ fill: color }"
      />
      <path
        data-name="パス 4978"
        d="M691.03 453.22a.749.749 0 0 0-1.06 0l-2.086 2.086a1.524 1.524 0 1 0 1.06 1.06l2.086-2.086a.749.749 0 0 0 0-1.06z"
        transform="translate(-674 -443.25)"
        :style="{ fill: color }"
      />
      <path
        data-name="パス 4979"
        d="M692.169 447.636a8.925 8.925 0 0 0-5.614-2.6V443.5h1.5a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0 0 1.5h1.5v1.537a8.925 8.925 0 0 0-5.614 2.6.75.75 0 0 0 1.06 1.06 7.5 7.5 0 1 1 0 10.607.75.75 0 0 0-1.06 1.06 9 9 0 0 0 12.727-12.727z"
        transform="translate(-672.305 -440.5)"
        :style="{ fill: color }"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'QualitySVG',
  props: {
    size: {
      type: String,
      default: '24px',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    color: {
      type: String,
      default: '#666666',
    },
  },
};
</script>
